import React from 'react'
import type { ReactNode } from 'react'
import { cn } from '../helpers/utils.js'

type Element = React.ElementRef<'div'>

interface GridProps {
  children?: ReactNode
  className?: string
}

interface GridItemProps {
  children?: ReactNode
  className?: string
  span?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 // 限制为具体的数字类型
  start?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 // 起始列位置
  end?: 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 // 结束列位置
}

const colSpanClasses = {
  1: 'col-span-1',
  2: 'col-span-2',
  3: 'col-span-3',
  4: 'col-span-4',
  5: 'col-span-5',
  6: 'col-span-6',
  7: 'col-span-7',
  8: 'col-span-8',
  9: 'col-span-9',
  10: 'col-span-10',
  11: 'col-span-11',
  12: 'col-span-12',
} as const

const colStartClasses = {
  1: 'col-start-1',
  2: 'col-start-2',
  3: 'col-start-3',
  4: 'col-start-4',
  5: 'col-start-5',
  6: 'col-start-6',
  7: 'col-start-7',
  8: 'col-start-8',
  9: 'col-start-9',
  10: 'col-start-10',
  11: 'col-start-11',
  12: 'col-start-12',
} as const

const colEndClasses = {
  2: 'col-end-2',
  3: 'col-end-3',
  4: 'col-end-4',
  5: 'col-end-5',
  6: 'col-end-6',
  7: 'col-end-7',
  8: 'col-end-8',
  9: 'col-end-9',
  10: 'col-end-10',
  11: 'col-end-11',
  12: 'col-end-12',
  13: 'col-end-13',
} as const

/**
 * Grid - 网格布局
 *
 * @description 基于CSS Grid的12列网格布局容器组件，提供灵活的响应式布局方案
 */
const Grid = React.forwardRef<Element, GridProps>(({ className, children }, forwardedRef) => {
  return (
    <div ref={forwardedRef} className={cn('laptop:gap-4 grid grid-cols-12 gap-3', className)}>
      {children}
    </div>
  )
})
Grid.displayName = 'Grid'

const GridItem = React.forwardRef<Element, GridItemProps>(
  ({ className, children, span = 12, start, end }, forwardedRef) => {
    return (
      <div
        ref={forwardedRef}
        className={cn(colSpanClasses[span], start && colStartClasses[start], end && colEndClasses[end], className)}
      >
        {children}
      </div>
    )
  }
)
GridItem.displayName = 'GridItem'

export { Grid, GridItem }
export type { GridProps, GridItemProps }
